module.exports = __webpack_public_path__ + "img/5.83738eb6.jpg";